/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetMainRegionAndRiskTerritoryListQueryDto
 */
export interface GetMainRegionAndRiskTerritoryListQueryDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetMainRegionAndRiskTerritoryListQueryDto
     */
    regions?: Array<string>;
}

/**
 * Check if a given object implements the GetMainRegionAndRiskTerritoryListQueryDto interface.
 */
export function instanceOfGetMainRegionAndRiskTerritoryListQueryDto(value: object): value is GetMainRegionAndRiskTerritoryListQueryDto {
    return true;
}

export function GetMainRegionAndRiskTerritoryListQueryDtoFromJSON(json: any): GetMainRegionAndRiskTerritoryListQueryDto {
    return GetMainRegionAndRiskTerritoryListQueryDtoFromJSONTyped(json, false);
}

export function GetMainRegionAndRiskTerritoryListQueryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMainRegionAndRiskTerritoryListQueryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'regions': json['regions'] == null ? undefined : json['regions'],
    };
}

export function GetMainRegionAndRiskTerritoryListQueryDtoToJSON(json: any): GetMainRegionAndRiskTerritoryListQueryDto {
    return GetMainRegionAndRiskTerritoryListQueryDtoToJSONTyped(json, false);
}

export function GetMainRegionAndRiskTerritoryListQueryDtoToJSONTyped(value?: GetMainRegionAndRiskTerritoryListQueryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'regions': value['regions'],
    };
}

